<script lang="ts" setup>
import HubCard from '@ui/composites/HubCard/HubCard.vue'
import Avatar from '@ui/components/Avatar/Avatar.vue'

import type { HubItem } from '~~/types/types'

defineProps<{
  reverse?: boolean
}>()

const { locale } = useI18n()
const localeRoute = useLocaleRoute()

const {
  public: { appLink },
} = useRuntimeConfig()

const take = 25

const queryData = computed(() => ({
  take,
  locale: locale.value,
}))

const pages = useState<{ data: HubItem[] }[]>('hubs', () => [])

const { data: firstPage } = await useNuxtApp().$client.hubs.getHubs.useQuery(
  queryData
)

watch(
  firstPage,
  (value) => {
    pages.value = []

    if (value?.data.length) {
      if (!pages.value.length) {
        pages.value.push({
          data: value?.data,
        })
      }
    }
  },
  {
    immediate: true,
  }
)
</script>

<template>
  <ClientOnly>
    <template v-for="{ data, i } in pages" :key="i">
      <UCarousel
        v-slot="{ item }"
        :items="data"
        loop
        :auto-scroll="{
          speed: 1,
          stopOnInteraction: false,
          stopOnMouseEnter: false,
          direction: reverse ? 'backward' : 'forward',
        }"
        :ui="{
          container: '',
          item: 'basis-auto max-w-100 w-full',
        }"
      >
        <NuxtLink :to="localeRoute('/hubs/' + item.slug)" class="no-underline">
          <HubCard
            :image="
              item.mediaData?.coverImage?.large
                ? `${appLink}/${item.mediaData?.coverImage?.large}`
                : ''
            "
            :coverImageDominantColors="
              item.mediaData
                ? Array.isArray(item.mediaData.coverImageDominantColors)
                  ? item.mediaData.coverImageDominantColors
                  : []
                : []
            "
          >
            <template #title> {{ item.title }} </template>
            <template v-if="item.members" #subheader>
              {{ item.members }} Members
            </template>
            <template #avatar>
              <Avatar
                :url="
                  item.mediaData?.coverImage?.large
                    ? `${appLink}/${item.mediaData?.coverImage?.large}`
                    : ''
                "
              />
            </template>
            <template v-if="item.hubType === 'nftCollection'" #badge>
              <Icon
                name="belong:hub-verified"
                class="min-w-4.75 max-w-4.75 min-h-5 max-h-5 ml-2"
              />
            </template>
          </HubCard>
        </NuxtLink>
      </UCarousel>
    </template>
  </ClientOnly>
</template>
